import { render, staticRenderFns } from "./NumberView.vue?vue&type=template&id=59bdb55a&scoped=true&"
import script from "./NumberView.vue?vue&type=script&lang=js&"
export * from "./NumberView.vue?vue&type=script&lang=js&"
import style0 from "./NumberView.vue?vue&type=style&index=0&id=59bdb55a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bdb55a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
